<template>
  <v-data-table
    :headers="headers"
    :items="LinesDI"
    :items-per-page="5"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>
          Ligne AGR
        </v-toolbar-title>
        <v-spacer />
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs}">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              Nouveau
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="LineAGREdit.libelle_ligneparametrage_agrs"
                      label="Libellé"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-select
                      v-model="LineAGREdit.type_valeur"
                      :items="type_valeurs"
                      item-text="text"
                      item-value="value"
                      label="Type de valeur"
                      single-line
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-select
                      v-model="LineAGREdit.id_composants"
                      :items="composantsList"
                      item-text="nom_web"
                      item-value="id"
                      label="Composant"
                      single-line
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="blue darke-1"
                @click="close"
              >
                Fermer
              </v-btn>
              <v-btn
                color="blue darke-1"
                @click="saveLineAGR"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogDelete"
          max-width="500px"
        >
          <v-card>
            <v-card-title class="text-h5">
              Are you sure you want to delete this item?
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="blue darken-1"
                text
                @click="closeDelete"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="deleteItemConfirm"
              >
                OK
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{item}">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        class="mr-2"
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:item.logo_organisations="{item}">
      <v-img
        :lazy-src="item.logo_organisations"
        max-height="150"
        max-width="250"
        :src="item.logo_organisations"
      />
    </template>
  </v-data-table>
</template>

<script>
  import paramettres from '@/services/ligne-agr.js'
  import composants from '@/services/composants.js'
  export default {
    data () {
      return {
        dialog: false,
        dialogDelete: false,
        headers: [
          { text: 'Actions', value: 'actions', sortable: false },
          {
            text: 'Indicateur',
            value: 'libelle_ligneparametrage_agrs',
          },
          {
            text: 'Libellé AGR',
            value: 'parametrage_agr.libelle_parametrage_agrs',
          },
          {
            text: 'Type de valeur',
            value: 'type_valeur',
          },
          {
            text: 'Libellé composant',
            value: 'composant.nom_web',
          },
        ],
        LinesDI: [],
        choix: [
          {
            text: 'Oui',
            value: '1',
          },
          {
            text: 'Non',
            value: '0',
          },
        ],
        type_valeurs: [
          {
            valeur: 'double',
            text: 'double',
          },
          {
            valeur: 'varchar',
            text: 'varchar',
          },
          {
            valeur: 'file',
            text: 'file',
          },
        ],
        composantsList: [],
        editedIndex: -1,
        LineAGREdit: {
          id: '',
          libelle_ligneparametrage_agrs: '',
          id_parametrage_agr: this.$route.params.AGR,
          id_composants: '',
          type_valeur: '',
          mesures: '',

        },
        LineAGR: {
          libelle_ligneparametrage_agrs: '',
          id_parametrage_agr: this.$route.params.AGR,
          id_composants: '',
          type_valeur: '',
          mesures: '',
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Ajouter une variable' : 'Modifier une variable'
      },
    },
    mounted () {
      console.log(this.editedIndex)
      paramettres.getLineAGR(this.$route.params.AGR).then(response => {
        this.LinesDI = response.data
      }).catch(err => {
        console.log(err)
      })
      composants.getComposants().then(response => {
        this.composantsList = response.data
        console.log(this.composantsList)
      }).catch(err => {
        console.log(err)
      })
    },
    methods: {
      saveLineAGR () {
        if (this.editedIndex > -1) {
          paramettres.updateLineAGR(this.LineAGREdit).then(response => {
            console.log(response.data)
            paramettres.getLineAGR(this.$route.params.AGR).then(response => {
              this.LinesDI = response.data
            })
            this.dialog = false
          }).catch(err => {
            console.log(err.response.data)
          })
        } else {
          paramettres.createLineAGR(this.LineAGREdit).then(response => {
            console.log(response.data)
            paramettres.getLineAGR(this.$route.params.AGR).then(response => {
              this.LinesDI = response.data
            })
            this.dialog = false
          }).catch(err => {
            console.log(err.response.data)
          })
        }
        this.close()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.LineAGREdit = Object.assign({}, this.LineAGR)
          this.editedIndex = -1
        })
      },
      editItem (item) {
        this.editedIndex = this.LinesDI.indexOf(item)
        this.LineAGREdit = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.LinesDI.indexOf(item)
        this.LineAGREdit = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        paramettres.deleteLineAGR(this.LineAGREdit).then(response => {
          paramettres.getLineAGR(this.$route.params.AGR).then(response => {
            this.LinesDI = response.data
          })
        }).catch(err => {
          console.log(err.response.data)
        })
        this.closeDelete()
      },
      navigateTo (item) {

      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.LineAGREdit = Object.assign({}, this.LineAGR)
          this.editedIndex = -1
        })
      },
    },
  }
</script>

<style scoped>

</style>
